import { CreatePluginMessageMap, WebviewId } from '@gitlab-org/webview-plugin';
import { DuoWorkflowEventPayload, DuoWorkflowInfo, DuoWorkflowStatus, ProjectInfo } from './types';

export const WEBVIEW_ID = 'duo-workflow' as WebviewId;
export const WEBVIEW_TITLE = 'GitLab Duo Workflow';

export type DuoWorkflowMessages = CreatePluginMessageMap<{
  webviewToPlugin: {
    notifications: {
      getUserWorkflows: [];
      getWorkflowById: {
        workflowId: string;
      };
      startWorkflow: {
        goal: string;
        image: string;
      };
      stopWorkflow: [];
      openUrl: {
        url: string;
      };
    };
  };
  pluginToWebview: {
    notifications: {
      updateProjects: ProjectInfo[];
      updateWorkflows: DuoWorkflowInfo[];
      workflowCheckpoint: DuoWorkflowEventPayload;
      workflowError: string;
      workflowStarted: string;
      workflowStatus: DuoWorkflowStatus;
    };
  };
}>;
